import React from 'react'
import { ThanksHeader } from '@components/thanksHeader/thanksHeader'
import { SocialNetworksList } from '@components'

interface ThanksSectionProps {
    thankTitle?: string
    imageUrl?: string
    imageAlt?: string
}

const ThanksSection = React.forwardRef<HTMLDivElement, ThanksSectionProps>(
    ({ thankTitle, imageUrl, imageAlt }, ref) => (
        <div
            ref={ref}
            tabIndex={-1}
            className="place-self-center max-w-screen-xl mx-auto"
        >
            <ThanksHeader
                title={thankTitle}
                description=""
                imageUrl={imageUrl}
                imageAlt={imageAlt}
            />
            <SocialNetworksList />
        </div>
    )
)

ThanksSection.displayName = 'ThanksSection'

export default ThanksSection
